import http from '@/api/http';
import OSS from 'ali-oss';
export default {
  getSTS(filename) {
    return http.get(`${window.configs['fe.api']}/api/v2/kanmanreportsts?filename=${filename}`);
  },

  getUploadData(filename) {
    return this.getSTS(filename)
      .then(res => {
        if (res.status === 0) {
          return res.data;
        } else {
          throw Error('获取sts出错');
        }
      })
      .then(res => {
        const {
          region,
          bucket,
          token: { AccessKeySecret, AccessKeyId, SecurityToken },
          filepath,
          link
        } = res;
        const client = new OSS({
          region,
          accessKeyId: AccessKeyId,
          accessKeySecret: AccessKeySecret,
          stsToken: SecurityToken,
          bucket
        });
        return { client, filepath, link };
      });
  },

  // 上传图片方法
  uploadHandle(fileData, options = {}) {
    return this.getUploadData(fileData.filename).then(res => {
      const { client, filepath } = res;
      fileData.filepath = filepath;
      return client.multipartUpload(filepath, fileData.file, options);
    });
  },

  getExtname(filename) {
    var index = filename.lastIndexOf('.');
    var suffix = filename.substr(index);
    return suffix;
  }
};
